import React from 'react';
import './WideImpactCounter.css'
import './odometer-theme-default.css'
import Odometer from 'react-odometerjs';

const WideImpactCounter = ({number, title, subText, horizontal, Compressed, merchantConfig}) => {
    const backgroundColor = merchantConfig?.backgroundColor
        ? { backgroundColor: merchantConfig.backgroundColor }
        : undefined;

    // 

    return (
        <section className={`${Compressed === 'true' ? 'flex-grow' : horizontal === 'true' ? 'flex-grow' : 'col-12'} p-2 d-grid`}>
            <div className="wide-impact-counter impact-counter" style={backgroundColor}>
                <div className="counter-numbers">
                    <Odometer value={number || "..."} format="(,ddd)" animation='count' />
                </div>
                <div className="counter-title">{title}</div>
                {subText && <div className="font-italics">{subText}</div>}
            </div>
        </section>
    )
};

export default WideImpactCounter